module.exports = __webpack_public_path__ + "media/images/sort_both-1aa21c0a262a0d176e0c2c32cb51b58d.png";